import { onTrackEvent } from '../events/onTrackEvent';

function initOnePageStoreToSdk(pageEvent) {
  const {
    onCartUpdate,
    onGetCartFailed,
    openLoginPopup,
    updateLoginPopupOutsideClickDisabled,
  } = pageEvent;

  const onePageStore = {
    onCartUpdate,
    onGetCartFailed,
    openLoginPopup,
    updateLoginPopupOutsideClickDisabled,
    onTrackEvent,
  };

  window.shopline = Object.assign(window.shopline || {}, {
    onePageStore,
  });
}
export default initOnePageStoreToSdk;
